// data.js
export const carouselImages = [
    { src: '/static/images/lb01.jpg' },
    { src: '/static/images/lb02.jpg' },
    { src: '/static/images/lb03.jpg' },
    { src: '/static/images/lb04.jpg' },
    { src: '/static/images/lb05.jpg' },
    { src: '/static/images/lb06.jpg' }
  ];
  
  export const publicity = {
    title: 'OUR ADVANTAGES',
    subtitle: '富垦精品路线;卓越来自于对每个过程的精益求精'
  };
  
  export const advantages = [
    '资质认证，品质保障',
    '技术团队，产品研发',
    '装备精良，专业生产',
    '物流及时，售后服务'
  ];
  
  export const descriptions = [
    '我们一直以专业专一的态度致力于电气成套设备的设计及生产制造,产品全面按照国家标准设计和制造，非标产品全部按照客户要求及安全考虑设计和制造。',
    '保证所提供的产品是全新、未使用过的，是用一流的工艺和绝佳材料制造而成的、技术先进且成熟可靠，在各个方面均符合国家标准要求。',
    '我们不断创新，从而使用产品价格控制在合理的范围内。我们在配电柜方面的组装、调试、安装、维护等方面积累了大量的现场工作经验。达到业内领先水平！',
    '产品在交货前对外观、规格、性能、数量和质量等进行了详细全面的检验，并出具了符合规定要求的合格证。'
  ];
  
  export const factory = {
    title: '厂房一角',
    image: '/static/images/yijiao.jpg'
  };
  
  export const assurances = [
    '我们的保证是--放心、舒心、放心',
    '这正是用户对我们产品的心情',
    '是我们高质量的产品与服务所得到的收获',
    '我们始终坚持质量就是企业的生命',
    '严格按照用户需求制造',
    '销售高质量、高品质、高安全性和高可靠性的产品',
    '同时完善售后服务。'
  ];